import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/**
 * フォールバック表示コンポーネント
 * フォールバック表示に関する責任を持つ
 */
interface FallbackDisplayProps {
  /** 表示するカスタムコンテンツ */
  content?: ReactNode;
  /** カスタムコンテンツが未指定時のデフォルトメッセージ */
  defaultMessage: string;
  /** ルートコンテナのCSSクラス */
  rootClassName?: string;
}
export const FallbackDisplay = ({
  content,
  defaultMessage,
  rootClassName
}: FallbackDisplayProps) => <div className={cn('h-full overflow-auto rounded-md bg-neutral-fill', rootClassName)}>
    <div className="flex items-center justify-center h-full min-h-[200px]">
      {content || <div className="text-center text-neutral-on-fill">{defaultMessage}</div>}
    </div>
  </div>;